import React from "react";

export default function LiveUserAvatar({ src, alt, className, ...props }) {
  return (
    <div className={`user-avatar ${className}`} {...props}>
      <img
        data-testid="live-user-avatar-image"
        id="live-user-avatar-image"
        src={src}
        alt={alt}
      />
    </div>
  );
}
